export default "__VITE_ASSET__DEdDq4sJ__"